import { useEffect, useRef } from "react";
import { Divider, Grid2 as Grid, Typography } from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router";

import { Form } from "@shared/components";
import {
  AgreementsAutocomplete,
  CategoriesAutocomplete,
  CatalogsAutocomplete,
} from "@shared/components/AutocompleteFields";

export function CompanyForm() {
  const translate = useTranslate();
  const { id } = useParams();
  const { watch, setValue } = useFormContext();
  const status = watch("status");
  const prevStatusRef = useRef(status);
  const isEdit = Boolean(id);

  useEffect(() => {
    if (status === "approved" && prevStatusRef.current !== "approved") {
      setValue("approved_terms_date", new Date().toISOString());
    }
    prevStatusRef.current = status;
  }, [status, setValue]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="corporate_name"
          label={translate("v1/company_admin.fields.corporate_name")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="name"
          label={translate("v1/company_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="cnpj"
          label={translate("v1/company_admin.fields.cnpj")}
          mask="cnpj"
          disabled={isEdit}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="order"
          label={translate("v1/company_admin.fields.order")}
          instructions="Quanto maior o rank mais alto aparecerá essa empresa"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="description"
          label={translate("v1/company_admin.fields.description")}
          multiline
          minRows={4}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <CatalogsAutocomplete
          name="plans"
          label={translate("v1/company_admin.fields.plans")}
          multiple
          required
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <CategoriesAutocomplete
          name="field_of_activity"
          label={translate("v1/company_admin.fields.field_of_activity")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("v1/company_admin.fields.agreement")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.DatePicker
          name="approved_terms_date"
          label={translate("v1/company_admin.fields.approved_terms_date")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <AgreementsAutocomplete
          name="creator_agreement"
          label={translate("v1/company_admin.fields.creator_agreement")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="creator_origin"
          label={translate("v1/company_admin.fields.creator_origin")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="approved_data"
          label={translate("v1/company_admin.fields.approved_data")}
          defaultChecked={false}
          disabled
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("v1/company_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="status"
          label={"Status"}
          options={[
            { value: "approved", label: "Aprovado" },
            { value: "pending-approval", label: "Pendente de Aprovação" },
            {
              value: "pending-terms",
              label: "Pendente de Assinatura do Contrato Digital",
            },
            { value: "pending-training", label: "Pendente de Treinamento" },
            { value: "denied", label: "Negado" },
          ]}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/company_admin.titles.contact_informations")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="owner"
          label={translate("v1/company_admin.fields.owner")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="telephone"
          label={translate("v1/company_admin.fields.telephone")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="cellphone"
          label={translate("v1/company_admin.fields.cellphone")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="email"
          label={translate("v1/company_admin.fields.email")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="site"
          label={translate("v1/company_admin.fields.site")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/company_admin.titles.images")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="logo"
          label={translate("v1/company_admin.fields.logo")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.SinglePhotoPicker
          name="cover_photo"
          label={translate("v1/company_admin.fields.cover_photo")}
          shape="square"
          size={150}
        />
      </Grid>
    </Grid>
  );
}
